// Strict shared chrome for systemFrame and clusterFrame. Only the
// kind-distinguishing tokens (fillVar, borderVar) and borderStyle vary;
// padding, border-width, border-radius, chip position, chip background,
// and typography are baked in so the nesting reads cleanly — same kind
// of object at different depths.
//
// chipBg defaults to var(--background), the canvas-only contract. If
// the frame ever renders against a non-canvas surface (popup, export),
// the caller passes a matching chipBg, but expect to re-evaluate the
// design at that point — the punch-through trick assumes chip bg
// matches surface bg.
//
// Spec: docs/superpowers/specs/2026-05-25-archviz-cluster-framing-design.md

interface FrameChromeProps {
  label: string;
  subtitle?: string;
  fillVar: string;
  borderVar: string;
  borderStyle: "solid" | "dashed";
  chipBg?: string;
}

export function FrameChrome({
  label,
  subtitle,
  fillVar,
  borderVar,
  borderStyle,
  chipBg = "var(--background)",
}: FrameChromeProps) {
  return (
    <div
      className="relative w-full h-full pointer-events-none"
      style={{
        background: `var(${fillVar})`,
        borderWidth: 1,
        borderStyle,
        borderColor: `var(${borderVar})`,
        borderRadius: 12,
      }}
    >
      <div
        className="absolute inline-flex items-baseline gap-1.5 px-2 font-semibold uppercase"
        style={{
          top: -9,
          left: 16,
          background: chipBg,
          letterSpacing: "0.08em",
          color: `var(${borderVar})`,
          fontSize: "calc(11px * var(--archviz-label-scale, 1))",
        }}
      >
        <span>{label}</span>
        {subtitle && (
          <>
            <span style={{ opacity: 0.7 }}>·</span>
            <span style={{ opacity: 0.7, fontWeight: 500, letterSpacing: "0.06em" }}>
              {subtitle}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
